/** 
 * Use as external script from public-api folder
 * requires jquery
 */

 
 import '../../../scss/booking-widget/v1/booking-widget.scss';
 import { init as init_token } from 'data/token';
 import { init as init_complete_page } from 'booking-widget/v1/complete';
 import { setup_ajax_triggers } from 'booking-widget/v1/common/util';
 
 (function ( $ ) {
     setup_ajax_triggers();
 
     $.fn.booking_widget_complete_page = function(options) {
         if (typeof options === 'undefined') {
             options = {};
         }
 
         let el = this;
 
         let opts = $.extend({
             context_el: el,
             maintenance_message: false
         }, options);
 
         $.when(init_token()).then(function() {
             // do whatever now
             init_complete_page(opts);
         });
 
         return el;
     }
 
 }( jQuery ));